import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesome, ModalBoxHelpIcon } from 'src/containers/Elements';
import { useDelayUnmount } from 'src/hooks/useDelayUnmount';
import { useModal } from 'src/hooks/useModal';

interface Props {
	selected: string;
	onChange: (val: string) => void;
}

export const CustomIconStatisticCard: FC<Props> = ({ selected, onChange }) => {
	const { t } = useTranslation();
	const [openModal, toggleModal] = useModal();
	const shouldRenderModal = useDelayUnmount(openModal, 350);
	return (
		<div className="p-3">
			<input
				type="text"
				id="title"
				value={selected}
				placeholder={t('text.enter-icon-code')}
				className="inputbox w-100"
				onChange={(e) => onChange(e.target.value)}
			/>
			<div
				style={{
					borderRadius: '8px'
				}}
				className="bg-gray-1 mt-3 p-3  my-3  align-items-center d-flex gap-2 w-100">
				<FontAwesome icon="info-circle" className="text-gray-3" />
				<div className="d-flex flex-column gap-1">
					<span className="text-gray-3">
						{t('forms.feature-icon')}
					</span>
					<div className="d-flex flex-wrap justify-content-between">
						<a
							href="https://fontawesome.com/"
							className="text-yellow fw-semibold"
							rel="noreferrer"
							target="_blank">
							https://fontawesome.com
						</a>
						<div
							className="d-flex gap-2 text-primary"
							style={{
								cursor: 'pointer'
							}}
							onClick={toggleModal}>
							<FontAwesome icon="eye" size="1x" />
							<span
								className="fs-sm fw-500"
								style={{
									textDecoration: 'underline'
								}}>
								{t('label.show-screen-shot-help')}
							</span>
						</div>
					</div>
				</div>
			</div>
			{shouldRenderModal && (
				<ModalBoxHelpIcon isOpen={openModal} onClose={toggleModal} />
			)}
		</div>
	);
};
